export default class Store_Storage {
  state = null;
  // read only
  defaultState = {
    timerRemaining: {
      // {$blockId}: int in seconds
    },
  };

  constructor(prefixId) {
    this.id = prefixId;
  }

  inIframe() {
    try {
      return window.self !== window.top;
    } catch (e) {
      return true;
    }
  }

  getStorageFallback() {
    return {
      getItem: () => null,
      setItem: () => {},
      removeItem: () => {},
    };
  }

  getLocalStorage() {
    // we need to mock localStorage because sometimes there is user that block third-party cookies
    if (this.inIframe()) {
      return this.getStorageFallback();
    }

    return window.localStorage;
  }

  getSessionStorage() {
    if (this.inIframe()) {
      return this.getStorageFallback();
    }

    return window.sessionStorage;
  }

  load() {
    const state = this.getLocalStorage().getItem("bd-" + this.id);
    this.state = state ? JSON.parse(state) : this.defaultState;
  }

  save(key, value) {
    this.state[key] = value;
    this.getLocalStorage().setItem("bd-" + this.id, JSON.stringify(this.state));
  }

  delete() {
    this.getLocalStorage().removeItem("bd-" + this.id);
  }
}
